module.exports = __webpack_public_path__ + "static/media/Moroso_thumbnail.d3c6b89b.png";